// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationRoleId: z.string().min(1).max(21),
    scopeId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationRoleId: z.string().min(1).max(21),
    scopeId: z.string().min(1).max(21),
});
export const OrganizationRoleResourceScopeRelations = Object.freeze({
    table: 'organization_role_resource_scope_relations',
    tableSingular: 'organization_role_resource_scope_relation',
    fields: {
        tenantId: 'tenant_id',
        organizationRoleId: 'organization_role_id',
        scopeId: 'scope_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationRoleId',
        'scopeId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
